export class FillReportSortField {
    static readonly Fill: number = 0;
    static readonly Publisher: number = 1;
    static readonly Country: number = 2;
    static readonly Requests: number = 3;
    static readonly ContentReady: number = 4;
}


// WEBPACK FOOTER //
// ./src/app/reports/fill-report/fill-report-sort.enum.ts